























































import Vue from 'vue';
import Component from 'vue-class-component';
import { Watch, Prop, PropSync } from 'vue-property-decorator';
import * as FORM_INTERFACE from '../interfaces/accessTicket.interface';
import * as rules from '@/modules/shared/shared/domain/rules';

@Component({
    components: {},
})
export default class AdditionalPerson extends Vue {
    @Prop()
    isFormComplete!: number;

    rules: any = rules;

    @PropSync('oldItem', {
        default: function() {
            return {} as FORM_INTERFACE.additionalPeopleInterface;
        },
    })
    additionalPerson!: FORM_INTERFACE.additionalPeopleInterface;

    @Watch('isFormComplete')
    sendData(value: boolean, oldValue: boolean) {
        this.$emit('receiveAdditionalPerson', this.additionalPerson);
    }
}
